export default {
    bindings: {
        loading: '=',
        data: '<',
        selectedEvent: '=',
        customisations: "=",
        eventFilters: '=',
        activeEvents: '=',
        noEvents: '<',
        filterEvents: '&',
        resetFilters: '&',
        resetAvailability: '&',
    },
    controller: 'selectEventController',
    template: require('../views/select.event.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/select.event.component.js